import Vue from 'vue'

export default class {

    static toggleSelection(item) {
        if(this.isSelected(item)) {
            this.unselect(item)
        } else
            this.select(item) 
    }

    static getSelectedItems(arr) {
        return arr.filter(item => item._selected)
    }

    static selectOne(item, arr) {
        this.unselectAll(arr)
        this.select(item)
    }

    static unselectAll(arr) {
        arr.forEach(item => {
            this.unselect(item)
        })
    }

    static select(item) {
        Vue.set(item, '_selected', true)
    }

    static unselect(item) {
        Vue.delete(item, '_selected')
    }

    static isSelected(item) {
        return Boolean(item._selected)
    }
    
}


// WEBPACK FOOTER //
// ./src/helpers/ItemSelection.js